import React from 'react';
import PropTypes from 'prop-types';
import { fonts } from '@constants/fonts';
import { FormControlLabel as MUIFormControlLabel, Radio } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';

// Styled Radio to match old material-ui 0.19 sizing
// Only sets icon size - padding should be controlled by consumer
const StyledRadio = withStyles({
  root: {
    padding: '9px', // MUI default
    '& .MuiSvgIcon-root': {
      height: '1.0625rem',
      width: '1.0625rem'
    }
  }
})(Radio);

const useStyles = makeStyles({
  label: {
    fontSize: fonts.md
  }
});

const RadioButton = props => {
  const classes = useStyles();
  const { disabled = false, ...data } = props;

  return (
    <MUIFormControlLabel
      classes={{ label: classes.label }}
      disabled={disabled}
      control={<StyledRadio color="primary" />}
      {...data}
    />
  );
};

RadioButton.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  value: PropTypes.string
};

export { StyledRadio as Radio };
export default RadioButton;
